<template>
  <div class="page-container">
    <VanEmpty
      image="search"
      description="没有找到页面~"
    />
  </div>
</template>

<script setup>
import { Empty as VanEmpty } from 'vant';
import 'vant/es/empty/style';
</script>

<style scoped lang="scss">
.page-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
